import { IPortfolio } from '@/interfaces/portfolioOptimization.interface'

export type SelectPortfolioState = {
  isComplete: boolean
  isExpanded: boolean
  selectedPortfolios: IPortfolio[]
}
export type Action =
  | { type: 'SET_PORTFOLIOS'; payload: IPortfolio[] }
  | { type: 'SET_COMPLETE'; payload: boolean }
  | { type: 'TOGGLE_EXPANDED' }
  | { type: 'RESET' }

export const selectPortfoliosInitialState: SelectPortfolioState = {
  isComplete: false,
  isExpanded: false,
  selectedPortfolios: [],
}

// Reducer function to handle state transitions
export const selectPortfolioReducer = (
  state: SelectPortfolioState,
  action: Action,
): SelectPortfolioState => {
  switch (action.type) {
    case 'SET_PORTFOLIOS':
      return {
        ...state,
        selectedPortfolios: action.payload,
      }
    case 'TOGGLE_EXPANDED':
      return { ...state, isExpanded: !state.isExpanded }
    case 'SET_COMPLETE':
      return { ...state, isComplete: action.payload }
    case 'RESET':
      return {
        ...selectPortfoliosInitialState,
      }
    default:
      throw new Error('Unknown action type')
  }
}
